<template>
  <div class="firmware-container">
    <div class="firmware-list">
      <div class="firmware-header">
        <h1 class="firmware-title">Akuvox Release Firmware</h1>
      </div>
      <el-table
        :data="firmwareList"
        :default-sort="{ prop: 'rom_name', order: 'ascending' }"
        :span-method="arraySpanMethod"
        border
        highlight-current-row>

        <el-table-column
          prop="device_model"
          label="DeviceModel"
          min-width="120">
          <template slot-scope="scope">
            <i class="el-icon-cpu table-icon"></i>
            <span style="margin-left: 10px">{{ scope.row.device_model }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="rom_name"
          label="Firmware"
          sortable
          min-width="160">
          <template slot-scope="scope">
            <i :class="[getIcon(scope.row.rom_name), 'table-icon']"></i>
            <span style="margin-left: 10px">{{ scope.row.rom_name }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column
          prop="operator"
          label="所有者"
          min-width="120">
          <template slot-scope="scope">
            <i class="el-icon-user table-icon"></i>
            <span style="margin-left: 10px">{{ scope.row.operator }}</span>
          </template>
        </el-table-column> -->

        <el-table-column
          prop="release_type"
          label="Type"
          min-width="80"
          :formatter="formatReleaseType">
        </el-table-column>

        <el-table-column
          prop="human_readable_size"
          label="FileSize"
          min-width="80">
        </el-table-column>

        <el-table-column
          prop="update_time"
          label="UpdateTime"
          min-width="120">
          <template slot-scope="scope">
            <span>{{ formatDate(scope.row.update_time) }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="download"
          label="Download"
          min-width="120">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleDownload(scope.row)">
              {{ getDownloadButtonText(scope.row.cloud) }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import enLocale from "element-ui/lib/locale/lang/en";
  import locale from "element-ui/lib/locale";

  locale.use(enLocale);

  export default {
    name: 'FirmwareList',
    data() {
      return {
        firmwareList: [],
        loading: false,
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    },
    watch: {
      '$route.query': {
        handler() {
          this.fetchData()
        },
        immediate: true
      }
    },
    methods: {
      arraySpanMethod({ row, column, rowIndex }) {
        if (column.property === 'rom_name' ||
            column.property === 'device_model' ||
            // column.property === 'operator' ||
            column.property === 'release_type' ||
            column.property === 'human_readable_size') {
          const prevRow = this.firmwareList[rowIndex - 1];
          const nextRow = this.firmwareList[rowIndex + 1];

          // 计算当前行的合并信息
          let rowspan = 1;
          let colspan = 1;

          // 向下查找相同的固件
          let currentIndex = rowIndex;
          while (nextRow &&
                 this.firmwareList[currentIndex + 1] &&
                 this.firmwareList[currentIndex + 1].rom_name === row.rom_name) {
            rowspan++;
            currentIndex++;
          }

          // 如果不是第一个相同的固件，则隐藏单元格
          if (prevRow && prevRow.rom_name === row.rom_name) {
            return {rowspan: 0, colspan: 0};
          }

          return {rowspan, colspan};
        }
      },

      fetchData() {
        this.loading = true
        const params = {
          page: this.currentPage,
          rows: this.pageSize,
          ...this.$route.query
        }

        if (!params.model_name) {
          this.loading = false
          return
        }

        this.$http['get'](
          'device-rom/release/phae4heVoh2goode/',
          params,
          (data) => {
            const processedData = [];
            data.data.results.forEach(item => {
              if (item.cloud !== '开发+测试') {
                processedData.push(item);
              }
            });
            this.firmwareList = processedData;
            this.total = data.data.count;
            this.loading = false;
          }
        )
      },

      getDownloadButtonText(cloud) {
        const cloudMap = {
          '美国': 'Download(US)',
          '欧洲+北亚A+中东A': 'Download(EU)',
          '亚洲+日本+国内+澳洲': 'Download(Asia)',
          '亚洲+日本+澳洲': 'Download(Asia)',
          '国内': 'Download(CN)'
        }
        return cloudMap[cloud] || 'Download'
      },

      handleSizeChange(val) {
        this.pageSize = val
        this.fetchData()
      },

      handleCurrentChange(val) {
        this.currentPage = val
        this.fetchData()
      },

      formatDate(cellValue) {
        if (!cellValue) return ''
        const date = new Date(cellValue)
        const options = {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        }
        return date.toLocaleDateString('en-US', options)
      },

      handleDownload(row) {
        const link = document.createElement('a')
        link.href = row.url
        link.download = row.rom_name
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      },

      getIcon(filename) {
        const ext = filename.split('.').pop().toLowerCase()
        const iconMap = {
          'zip': 'el-icon-document',
          'rar': 'el-icon-document',
          'rom': 'el-icon-document',
          '7z': 'el-icon-document',
          'txt': 'el-icon-document',
          'pdf': 'el-icon-document',
          'doc': 'el-icon-document',
          'docx': 'el-icon-document'
        }
        return iconMap[ext] || 'el-icon-document'
      },

      formatReleaseType(row, column, cellValue) {
        const typeMap = {
          0: 'unknown',
          1: 'Release',
          2: 'Beta'
        }
        return typeMap[cellValue] || 'unknown'
      },
    }
  }
</script>

<style lang="less" scoped>
.firmware-container {
  padding: 24px;
  display: flex;
  justify-content: center;
  min-height: 100%;
  background-color: #f5f7fa;
}

.firmware-list {
  width: 100%;
  max-width: 1200px;
  padding: 0px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .firmware-header {
    background: linear-gradient(to right, #5B86E5, #36D1DC);
    padding: 24px 32px;
    margin: 0;
    border-radius: 8px 8px 0 0;
    position: relative;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 6px;
      background: rgba(255, 255, 255, 0.1);
    }
  }

  .firmware-title {
    margin: 0;
    margin-bottom: 24px;
    color: #fff;
    font-weight: 800;
    font-size: 36px;
    position: relative;
    padding-left: 12px;
    letter-spacing: 0.5px;
  }

  /deep/ .el-table {
    width: calc(100% - 48px) !important;
    margin: 24px;
    border-radius: 4px;
    overflow: hidden;

    th {
      background-color: #f5f7fa !important;
      color: #606266;
      font-weight: 600;
      height: 50px;
    }

    td {
      padding: 12px 8px;
      word-break: break-all;
      vertical-align: middle;
    }

    .cell {
      display: flex;
      align-items: center;
    }
  }

  /deep/ .table-icon {
    color: #409EFF;
    font-size: 18px;
    vertical-align: middle;
  }

  /deep/ .el-button--text {
    color: #409EFF;
    padding: 0 8px;
    font-weight: 500;

    &:hover {
      color: #66b1ff;
    }
  }

  .pagination-container {
    margin: 0 24px;
    text-align: right;
    padding: 16px 0;
    border-top: 1px solid #EBEEF5;
  }

  .firmware-log {
    padding: 24px;
    background-color: #f8f9fa;
    border-radius: 4px;

    .el-form-item {
      margin-bottom: 16px;
      width: 100%;

      /deep/ .el-form-item__label {
        color: #606266;
        font-weight: 500;
      }
    }
  }

  .cloud-info {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}
</style>
